<template>
  <div class="quantity">
    <div class="quantity__content">
      <IconButton
        icon="minus"
        view="action"
        :disabled="value <= min"
        class="quantity__action"
        @click="$emit('decrease')"
      />
      <div class="quantity__value">
        {{ value }}
      </div>
      <IconButton
        icon="plus"
        view="action"
        :disabled="value >= max"
        class="quantity__action"
        @click="$emit('increase')"
      />
    </div>
  </div>
</template>

<script>
import IconButton from '@/components/IconButton.vue';

export default {
  name: 'Quantity',
  components: {
    IconButton,
  },
  props: {
    min: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: 1000,
    },
    value: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="stylus">
.quantity
  display block
  &__content
    display flex
    align-items center
    font-size 1.8em

  &__value
    width 4.4em
    font-weight 700

  &__action
    padding 0.85em
    border-radius 0.25em
</style>
